import { render, staticRenderFns } from "./c_home_hot.vue?vue&type=template&id=50f148c3&scoped=true&"
import script from "./c_home_hot.vue?vue&type=script&lang=js&"
export * from "./c_home_hot.vue?vue&type=script&lang=js&"
import style0 from "./c_home_hot.vue?vue&type=style&index=0&id=50f148c3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f148c3",
  null
  
)

export default component.exports